import script from "./Freshchat.vue?vue&type=script&lang=js"
export * from "./Freshchat.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__